import { FC, useEffect } from "react";
import { Container } from "@mui/material";
import BottomSpacedPageHeader from "components/common/ui/BottomSpacedPageHeader";
import { useAppDispatch, useAppSelector } from "hooks/useReduxStore";
import foodPurchasingGuideSelector from "store/selectors/inventory/foodPurchasingGuideSelector";
import { usePromptSnackBar } from "components/common/ui/PromptSnackBarProvider";
import { foodPurchasingGuideActions } from "store/slices/inventory/foodPurchasingGuideSlice";
import CycleFoodPurchaseStepper from "components/inventory/ui/cyclePurchasing/CycleFoodPurchaseStepper";

interface CyclePurchasingToolPageProps {}

const CycleFoodPurchasingPage: FC<CyclePurchasingToolPageProps> = () => {
  const dispatch = useAppDispatch();
  const promptSnackBar = usePromptSnackBar();
  const purchasingGuideWarnings = useAppSelector(
    foodPurchasingGuideSelector.foodPurchasingGuideWarnings,
  );

  useEffect(() => {
    if (purchasingGuideWarnings) {
      promptSnackBar.setPromptProps({
        isOpen: true,
        message: purchasingGuideWarnings,
        severity: "warning",
        autoHeightDuration: 15000,
        onPromptClose: () => {
          dispatch(
            foodPurchasingGuideActions.clearFoodPurchasingGuideWarning(),
          );
        },
      });
    }
  }, [dispatch, promptSnackBar, purchasingGuideWarnings]);

  return (
    <Container>
      <BottomSpacedPageHeader>Simple Purchasing Tool</BottomSpacedPageHeader>
      <CycleFoodPurchaseStepper />
    </Container>
  );
};

export default CycleFoodPurchasingPage;
